// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1klgljz0 {
  max-width: 240px;
}
._1klgljz1 {
  width: var(--_18w76bw1w);
  text-align: right;
  padding-left: var(--_18w76bwc);
  background-color: #ebf7fb;
  color: var(--_18w76bw31);
  align-self: stretch;
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
}
._1klgljz2 {
  width: var(--_18w76bw1u);
  text-align: left;
  border-color: #ebf7fb !important;
  border-radius: var(--_18w76bw4m);
  -moz-appearance: textfield;
  color: var(--_18w76bw31);
  padding: 0;
  padding-right: var(--_18w76bwc);
}
._1klgljz2::-webkit-outer-spin-button, ._1klgljz2::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
._1klgljz3 {
  font-size: var(--_18w76bw3p);
}
@media screen and (min-width: 768px) {
  ._1klgljz0 {
    max-width: 180px;
  }
  ._1klgljz3 {
    max-width: 220px !important;
  }
}
@media screen and (min-width: 992px) {
  ._1klgljz0 {
    max-width: 215px;
  }
}
@media screen and (min-width: 1024px) {
  ._1klgljz0 {
    max-width: 180px;
  }
  ._1klgljz3 {
    font-size: 17px;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,8BAA8B;EAC9B,yBAAyB;EACzB,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,gCAAgC;EAChC,gCAAgC;EAChC,0BAA0B;EAC1B,wBAAwB;EACxB,UAAU;EACV,+BAA+B;AACjC;AACA;EACE,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,4BAA4B;AAC9B;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["._1klgljz0 {\n  max-width: 240px;\n}\n._1klgljz1 {\n  width: var(--_18w76bw1w);\n  text-align: right;\n  padding-left: var(--_18w76bwc);\n  background-color: #ebf7fb;\n  color: var(--_18w76bw31);\n  align-self: stretch;\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n._1klgljz2 {\n  width: var(--_18w76bw1u);\n  text-align: left;\n  border-color: #ebf7fb !important;\n  border-radius: var(--_18w76bw4m);\n  -moz-appearance: textfield;\n  color: var(--_18w76bw31);\n  padding: 0;\n  padding-right: var(--_18w76bwc);\n}\n._1klgljz2::-webkit-outer-spin-button, ._1klgljz2::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n._1klgljz3 {\n  font-size: var(--_18w76bw3p);\n}\n@media screen and (min-width: 768px) {\n  ._1klgljz0 {\n    max-width: 180px;\n  }\n  ._1klgljz3 {\n    max-width: 220px !important;\n  }\n}\n@media screen and (min-width: 992px) {\n  ._1klgljz0 {\n    max-width: 215px;\n  }\n}\n@media screen and (min-width: 1024px) {\n  ._1klgljz0 {\n    max-width: 180px;\n  }\n  ._1klgljz3 {\n    font-size: 17px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
